export const toPercent = (value, total) =>
  total > 0 ? Math.round((value / total) * 100) : 0;
